import { IPaginationResourceShort } from '../../props/general';
import { IVesselResourceProps, IVesselResourceShortProps } from '../../props/vessels/vessel';
import Request from '../request';

const VesselService = {
  retrieve: async (qs?: string): Promise<{ data: IVesselResourceShortProps[], pagination: IPaginationResourceShort }> => {
    try {
      const results = await Request.get(`/api/vessels?${qs || ''}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  read: async (id: string): Promise<IVesselResourceProps> => {
    try {
      const results = await Request.get(`/api/vessels/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  create: async (data: FormData): Promise<IVesselResourceProps> => {
    try {
      const result = await Request.post(`/api/vessels`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  update: async (id: string, data: FormData): Promise<IVesselResourceProps> => {
    try {
      const result = await Request.post(`/api/vessels/${id}?_method=PUT`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  }
};

export default VesselService;
